/**
 * Cliente do Supabase Auth no navegador — SÓ para login/sessão.
 * O navegador nunca consulta o banco: dados vêm sempre da nossa API.
 * Usa apenas a chave PÚBLICA (publishable). Chaves secretas nunca ficam em VITE_*.
 */
import { createClient, type SupabaseClient } from "@supabase/supabase-js";

const url = import.meta.env["VITE_SUPABASE_URL"] as string | undefined;
const publishableKey = import.meta.env["VITE_SUPABASE_PUBLISHABLE_KEY"] as string | undefined;

export const authConfigured = Boolean(url && publishableKey);

export const supabase: SupabaseClient | null = authConfigured
  ? createClient(url!, publishableKey!, {
      auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
    })
  : null;

/** Token de acesso atual (renovado automaticamente pelo SDK). */
export async function currentAccessToken(): Promise<string | null> {
  if (!supabase) return null;
  const { data } = await supabase.auth.getSession();
  return data.session?.access_token ?? null;
}
